const image = {
  baseStyle: {},
  variants: {},
}

export default image;